// extracted by mini-css-extract-plugin
module.exports = {"content":"Contact_content__2Fy-D"};